import type { ErrorEvent } from "@sentry/react";

/** Keep diagnostic locations; patient text and HTTP payloads never enter telemetry. */
export function privateErrorEvent(event: ErrorEvent): ErrorEvent {
  return {
    type: undefined,
    event_id: event.event_id,
    timestamp: event.timestamp,
    platform: event.platform,
    level: event.level,
    release: event.release,
    dist: event.dist,
    environment: event.environment,
    exception: event.exception ? {
      values: event.exception.values?.map((exception) => ({
        type: /^(?:[A-Za-z]{1,40})?Error$/.test(exception.type ?? "") ? exception.type : "Error",
        value: "Client error; inspect the application stack trace.",
        stacktrace: exception.stacktrace ? {
          frames: exception.stacktrace.frames?.map((frame) => ({
            filename: assetLocation(frame.filename),
            lineno: frame.lineno,
            colno: frame.colno,
            in_app: frame.in_app,
          })),
        } : undefined,
      })),
    } : undefined,
  };
}

function assetLocation(filename: string | undefined): string | undefined {
  if (!filename) return undefined;
  try {
    const url = new URL(filename, "https://application.invalid");
    return /^\/assets\/[A-Za-z0-9_.-]+\.js$/.test(url.pathname) ? url.pathname : undefined;
  } catch {
    return undefined;
  }
}
